import type { CaseStage, MoneyView } from '@tex/finance-shared'

export function formatDate(iso: string | null): string {
  if (!iso) return '—'
  return new Date(iso).toLocaleString(undefined, { dateStyle: 'medium', timeStyle: 'short' })
}

export function formatDay(isoDate: string | null): string {
  if (!isoDate) return '—'
  return new Date(`${isoDate}T00:00:00`).toLocaleDateString(undefined, { dateStyle: 'medium' })
}

export function formatAmount(m: MoneyView): string {
  return new Intl.NumberFormat('en-US', { style: 'currency', currency: m.currency }).format(m.amount_minor / 100)
}

/** Human label for a snake_case enum value. */
export function humanize(value: string): string {
  return value.replace(/_/g, ' ')
}

export const STAGE_LABELS: Record<CaseStage, string> = {
  lead: 'Lead',
  application: 'Application',
  review: 'Tex review',
  lender_review: 'Lender review',
  offer_review: 'Offer review',
  closing: 'Closing',
  funded: 'Funded',
  closed: 'Closed',
}
